"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var router_1 = require("./router");
var stack_1 = __importDefault(require("./stack"));
var view_1 = __importDefault(require("../pre/view"));
var form_1 = __importDefault(require("../pre/form"));
var utils_1 = require("./utils");
var App = function (props) {
    var dataDef = props.dataDef, Data = props.Data, CustomListContainer = props.CustomListContainer, CustomListItem = props.CustomListItem, noDataMessages = props.noDataMessages, NoDataComponents = props.NoDataComponents;
    var ViewUI = view_1["default"](dataDef);
    var FormUI = form_1["default"](dataDef);
    utils_1.displayDeprecatedWarnings(dataDef);
    var newDataDef = utils_1.transformOldStructureToNew(dataDef);
    if (newDataDef.detailPage === 'split') {
        return (react_1["default"].createElement(router_1.SplitRouter, { FormUI: FormUI, ViewUI: ViewUI, dataDef: newDataDef, Data: Data, extra: props.extra, CustomListContainer: CustomListContainer, CustomListItem: CustomListItem, noDataMessages: noDataMessages, NoDataComponents: NoDataComponents }));
    }
    if (newDataDef.detailPage === 'stack') {
        return (react_1["default"].createElement(stack_1["default"], { FormUI: FormUI, ViewUI: ViewUI, dataDef: newDataDef, Data: Data, extra: props.extra, CustomListContainer: CustomListContainer, CustomListItem: CustomListItem, noDataMessages: noDataMessages, NoDataComponents: NoDataComponents }));
    }
    return (react_1["default"].createElement(router_1.DefaultRouter, { FormUI: FormUI, ViewUI: ViewUI, dataDef: newDataDef, Data: Data, extra: props.extra, CustomListContainer: CustomListContainer, CustomListItem: CustomListItem, noDataMessages: noDataMessages, NoDataComponents: NoDataComponents }));
};
exports["default"] = App;
